const TRANSPORT_MESSAGE_PATTERN =
  /load failed|failed to fetch|network\s*(request)?\s*(error|failed)|connection\s+(lost|refused|reset|closed|failed|was lost)|network connection was lost/i

const RETRYABLE_AUTH_FETCH_ERROR_NAME = 'AuthRetryableFetchError'

export function isTransportFailure(err: unknown): boolean {
  if (err instanceof TypeError) {
    return TRANSPORT_MESSAGE_PATTERN.test(err.message)
  }
  return (err as { name?: string } | null | undefined)?.name === RETRYABLE_AUTH_FETCH_ERROR_NAME
}
